module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAJCAYAAADzRkbkAAAAF0lEQVQImWP4////fyYGBgYGQgQDAwMAqusEDVLvpKwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/copyright/line.png
// module id = 73gW
// module chunks = 1